function Spinner() {
  return (
    <div className="spinner">
      <div className="wrap">
        <div className="wrap-loader">
          <span className="loader"></span>
        </div>
      </div>
      <style jsx>{`
        .wrap {
          position: relative;
        }
        .wrap-loader {
          position: absolute;
          background: var(--foreground-blur);
          min-height: 400px;
          z-index: 1;
          width: 100%;
          backdrop-filter: blur(0.5px);
          overflow: hidden;
        }
        .loader {
          position: absolute;
          right: 45%;
          top: 45%;
          transform: translate(-50%, -50%);
          border: 3px solid var(--primary);
          border-radius: 100%;
          border-top: 3px solid var(--grey-lighter);
          width: 40px !important;
          height: 40px !important;
          -webkit-animation: spin 1s linear infinite;
          animation: spin 1s linear infinite;
        }
        @-webkit-keyframes spin {
          0% {
            -webkit-transform: rotate(0deg);
          }
          100% {
            -webkit-transform: rotate(360deg);
          }
        }
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
        @media only screen and (min-width: 46.875em) {
          .loader {
            position: absolute;
            right: 50%;
            top: 50%;
          }
        }
      `}</style>
    </div>
  );
}

export default Spinner;
